import React, {Component} from 'react'

import CRUDManagerGenerator from '../generators/CRUDGenerator'
import {checkPermission, MISC_CAN_CREATE_ADDRESS_TYPES, MISC_CAN_EDIT_ADDRESS_TYPES} from "../../../lib/permissions";

const create = {
    table: 'address_types',
    mutationType: 'upsert_',
    schema: {
        title: 'Create Address Type',
        type: 'object',
        required: ['description'],
        properties: {
            description: {type: 'string', title: 'Description'}
        }
    }
}

const update = {
    table: 'address_types',
    mutationType: 'upsert_',
    schema: {
        title: 'Update Address Type',
        type: 'object',
        required: ['description'],
        properties: {
            address_type_id: {type: 'integer'},
            description: {type: 'string', title: 'Description'}
        }
    },
    uiSchema: {
        address_type_id: {"ui:widget": "hidden"},
    },
}

const read = {
    title: 'Address Types',
    description: 'Address types allow you to categorise addresses associated with clients, projects and invoices.',
    table: 'address_types',
    fields: ['address_type_id', 'description'],
    uniqueKey: 'address_type_id',
    columns: [
        {Header: 'ID', accessor: 'address_type_id', maxWidth: '100'},
        {Header: 'Desc', accessor: 'description'}
    ]
}

const config = {
    create,
    read,
    update
}


const CRUDManager = CRUDManagerGenerator(config)

class AddressTypes extends Component{

    render(){
        return (
            <CRUDManager
                canCreate={checkPermission(MISC_CAN_CREATE_ADDRESS_TYPES)}
                canEdit={checkPermission(MISC_CAN_EDIT_ADDRESS_TYPES)}
            />
        )
    }
}

export default AddressTypes